module.exports = __webpack_public_path__ + "static/media/about-us.be2748f1.jpg";